export default "__VITE_ASSET__BlqG4NJ8__"